document.addEventListener('DOMContentLoaded', function() {
	const slider = document.querySelector('.auto-slider');
	const dots = document.querySelectorAll('.dots-container .dot');
	const setIntervalTimer = slider.dataset.interval;
	const slides = Array.from(slider.children);
	const totalSlides = slides.length - 1;
	const transitionDuration = 800; // Make sure this matches your CSS transition duration
	let currentIndex = 0;
	let interval;
	let isUserScrolling = false; // To track manual scrolling
	let scrollTimeout;
	let isTransitioning = false; // To prevent multiple slide transitions

	// Function to update active dot
	const updateActiveDot = (index) => {
		dots.forEach(dot => dot.classList.remove('active'));
		dots[index % totalSlides].classList.add('active'); // Update dot based on currentIndex
	};

	// Function to start the auto-slide
	const startAutoSlide = () => {
		if (!interval) {
			interval = setInterval(autoSlide, setIntervalTimer - transitionDuration);
		}
	};

	// Function to stop the auto-slide
	const stopAutoSlide = () => {
		clearInterval(interval);
		interval = null; // Ensure the interval is fully cleared to prevent overlapping intervals
	};

	// Function to handle automatic sliding
	const autoSlide = () => {
		if (isUserScrolling || isTransitioning) return; // Prevent auto slide if user is scrolling or a slide is transitioning

		const slideWidth = slides[0].offsetWidth;
		isTransitioning = true; // Mark as transitioning to prevent interruptions
		currentIndex++;

		// Smooth scroll to the next slide
		slider.scrollTo({ left: slideWidth * currentIndex, behavior: 'smooth' });

		// If we've reached the cloned last slide, wait for the transition to finish, then reset to the first slide
		if (currentIndex >= totalSlides) {
			setTimeout(() => {
				slider.scrollTo({ left: 0, behavior: 'instant' });
				currentIndex = 0;
				updateActiveDot(currentIndex);
				isTransitioning = false; // Mark transition as complete
			}, transitionDuration); // Wait for the transition to finish before resetting
		} else {
			setTimeout(() => {
				updateActiveDot(currentIndex);
				isTransitioning = false; // Mark transition as complete after each slide
			}, transitionDuration); // Ensure the next slide waits for the transition duration to complete
		}
	};

	startAutoSlide();

	// Handle dot clicks
	dots.forEach((dot, index) => {
		dot.addEventListener('click', (event) => {
			stopAutoSlide(); // Stop the auto-slide to prevent speed up
			currentIndex = index; // Update the current index based on the clicked dot
			const slideWidth = slides[0].offsetWidth;
			slider.scrollTo({ left: slideWidth * currentIndex, behavior: 'smooth' });

			updateActiveDot(currentIndex);
			setTimeout(() => {
				startAutoSlide();  // Restart the auto-slide after dot click
			}, transitionDuration); // Wait for the transition to complete before restarting auto-slide
		});
	});

	// Pause the auto-slide on hover
	slider.addEventListener('mouseenter', function() {
		stopAutoSlide();
	});

	// Resume the auto-slide when not hovering
	slider.addEventListener('mouseleave', function() {
		startAutoSlide();
	});


	let isManualScroll = false; // To track if the scroll is manual or JS-triggered

// Detect if user scrolls with mouse or touch
	slider.addEventListener('wheel', function() {
		isManualScroll = true;
	});
	slider.addEventListener('touchstart', function() {
		isManualScroll = true;
	});

	// Detect manual scroll and update active dot
	slider.addEventListener('scroll', function() {
		stopAutoSlide(); // Stop auto-slide during manual scroll
		isUserScrolling = true;

		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			isUserScrolling = false;
			isManualScroll = false;
			slides[totalSlides].classList.remove('hidden');

			startAutoSlide();
		}, 200); // Wait for user to stop scrolling before restarting auto-slide

		// Calculate the new index based on scroll position
		const slideWidth = slides[0].offsetWidth;
		const newIndex = Math.round(slider.scrollLeft / slideWidth); // Round to nearest slide

		// Update the current index and active dot
		if (newIndex !== currentIndex) {
			currentIndex = newIndex;
			updateActiveDot(currentIndex);
		}
		// Check if the user is scrolling near the last slide
		if (currentIndex === totalSlides - 1 && isManualScroll) {
			// Add the hidden class to the last (duplicate) slide while the user is scrolling
			slides[totalSlides].classList.add('hidden');
		} else {
			// Ensure the last slide is visible if we're not near the end
			slides[totalSlides].classList.remove('hidden');
		}
	});
});
